import { render, staticRenderFns } from "./BCOptionalFeaturesPassword.vue?vue&type=template&id=7d0a7d10"
import script from "./BCOptionalFeaturesPassword.vue?vue&type=script&lang=js"
export * from "./BCOptionalFeaturesPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports